<template>
  <b-input
    v-model="inputValue"
    :class="$style.input"
    type="tel"
    :min="0"
    :max="999"
    :step="1"
    inputmode="numeric"
    pattern="[0-9]*"
    novalidate
    @keypress="checkInputValue($event)"
  />
</template>

<script>
export default {
  name: 'BaseScoreInput',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      inputValue: this.value,
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.inputValue = newValue
      }
    },
    inputValue(value) {
      this.$emit('input', value)
    },
  },
  methods: {
    checkInputValue(event) {
      // eslint-disable-next-line eqeqeq
      if (parseInt(event.key) != event.key) {
        event.preventDefault()
      } else {
        const newValue = parseInt(`${event.target.value}${event.key}`)
        if (newValue >= 1000) {
          this.inputValue = 0
          event.preventDefault()
        } else {
          return true
        }
      }
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .input {
    color: $color-midnight-blue !important;
    text-align: center;
    font-size: $font-size-xxxlarge !important;
    font-weight: 600 !important;
    background-color: $color-bleached-silk !important;
    border: none !important;
    border-radius: .5rem !important;
    box-shadow: inset 0px 1px 2px 0px rgba(0,0,0,0.2) !important;
    padding: 2.5rem 0 !important;
    max-width: 200px;
  }
</style>
